import { z } from "zod";

/**
 * Form schema for the PEM `fasteners5` admin page. Live RDS column is
 * `min_sheet_thickness varchar(50)`; FE still validates as a non-negative
 * number, but the value travels as a string end-to-end.
 */
export const fastenerSchema = z.object({
  partNo: z.string().trim().min(1, "Part No is required").max(30),
  minSheetThickness: z
    .union([z.literal(""), z.coerce.number().nonnegative("Must be non-negative")])
    .optional(),
});

export type FastenerFormData = z.infer<typeof fastenerSchema>;

/**
 * Form schema for the PROFIL `profil_fasteners` admin page. RDS shape
 * (verified 2026-06-01): `(part_name varchar(20), type varchar(10),
 * riveting_force_kn numeric(8,2))`. Different domain attributes from PEM —
 * NO thickness column exists on this table.
 */
export const profilFastenerFormSchema = z.object({
  partNo: z.string().trim().min(1, "Part No is required").max(20),
  type: z.string().trim().max(10).optional(),
  rivetingForceKn: z
    .union([z.literal(""), z.coerce.number().nonnegative("Must be non-negative")])
    .optional(),
});

export type ProfilFastenerFormDataV2 = z.infer<typeof profilFastenerFormSchema>;

export const fastenerToolingMappingSchema = z.object({
  fastenerId: z.string().min(1, "Fastener ID is required"),
  toolingSetId: z.string().min(1, "Tooling Set ID is required"),
  notes: z.string().optional(),
});

export type FastenerToolingMappingFormData = z.infer<typeof fastenerToolingMappingSchema>;

export const toolingSetSchema = z.object({
  id: z.string().min(1, "ID is required"),
  label: z.string().min(1, "Label is required"),
  machine: z.string().min(1, "Machine is required"),
  toolingJson: z.string().refine((val) => {
    if (!val.trim()) return true;
    try { JSON.parse(val); return true; } catch { return false; }
  }, "Must be valid JSON"),
});

export type ToolingSetFormData = z.infer<typeof toolingSetSchema>;

export const profilFastenerSchema = z.object({
  id: z.string().min(1, "ID is required"),
  label: z.string().min(1, "Label is required"),
  dataJson: z.string().refine((val) => {
    if (!val.trim()) return true;
    try { JSON.parse(val); return true; } catch { return false; }
  }, "Must be valid JSON"),
});

export type ProfilFastenerFormData = z.infer<typeof profilFastenerSchema>;

export const profilInDieOptionSchema = z.object({
  id: z.string().min(1, "ID is required"),
  label: z.string().min(1, "Label is required"),
  dataJson: z.string().refine((val) => {
    if (!val.trim()) return true;
    try { JSON.parse(val); return true; } catch { return false; }
  }, "Must be valid JSON"),
});

export type ProfilInDieOptionFormData = z.infer<typeof profilInDieOptionSchema>;
